import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles, createStyles } from '@material-ui/core';
import BottomDrawerLayout, {
  DrawerSnapType,
} from '../../bottom-drawer-layout/BottomDrawerLayout';
import OutageLocationCheckBreakerPopup from './OutageLocationCheckBreakerPopup';

const useStyles = makeStyles(() =>
  createStyles({
    bottomSheet: {
      padding: '20px 20px 0',
      paddingTop: 0,
    },
  }),
);

type Props = {
  open: boolean;
  onClose: () => void;
  onProceed: () => void;
  onReset: () => void;
  onPrevious: () => void;
};

const OutageCheckBreakersReportPopupMob: FC<Props> = ({
  onClose,
  onProceed,
  onReset,
  onPrevious,
}: Props) => {
  const classes = useStyles();
  return (
    <BottomDrawerLayout
      onClose={onClose}
      data-testid={'notification-options'}
      refId={0}
      defaultSnap={DrawerSnapType.default}
    >
      <Box component="div" className={classes.bottomSheet}>
        <OutageLocationCheckBreakerPopup
          onClose={onClose}
          onProceed={onProceed}
          onReset={onReset}
          onPrevious={onPrevious}
        />
      </Box>
    </BottomDrawerLayout>
  );
};

export default OutageCheckBreakersReportPopupMob;
